import { render } from "./App.vue?vue&type=template&id=2cf52c43&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2cf52c43&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-2cf52c43"

export default script